export type Value = string[] | string;

export const hasMultipleIoIs = (value: Value | null | undefined): value is string[] => {
  return Array.isArray(value) && value.length > 1;
};
